import React, { useState } from 'react';
import "react-toastify/dist/ReactToastify.css";
import AdminNavbar from './AdminNavbar';
import Sidebar from './Sidebar';

export default function AdminLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <AdminNavbar onToggleSidebar={() => setSidebarOpen(prev => !prev)} />
      {sidebarOpen && (
        <div
          className="lg:hidden z-30 fixed inset-0 bg-black/50"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="min-h-screen ml-0 lg:ml-[260px] pt-[var(--admin-navbar-height)] content">{children}</div>
    </div>
  );
}
